import React, {Component} from 'react'
import ChatRoom from '../../containers/ChatRoomContainer'
import detect from 'browser-detect'

// Import Image
import close from '../../images/close-white.png'
import iconSupportChat from '../../images/icon-support-chat.png'

// Import SCSS
import './FloatingSupportChat.scss'

class FloatingSupportChat extends Component {
  constructor(props) {
    super(props)
    this.html = document.querySelector('html')
  }

  componentDidMount() {
    this.props.fetchChatrooms()
    this.props.fetchNotifications()
  }
  componentDidUpdate() {
    if(detect().mobile) {
      this.html.classList.toggle('modal-chatroom-open', this.props.showChatRoom)
    }
  }
  handleToggleChatroom() {
    this.props.fetchNotifications()
    this.props.toggleShowChatRoom()
  }
  render() {
    return <div className="floating-support">
      {this.props.showChatRoom &&
        <div className="floating-support-chat">
          <div className="floating-support-chat__wrapper">
            <div className="floating-support-chat__header">
              <span className="floating-support-chat__header__name">サポートチャット</span>
              <button onClick={this.handleToggleChatroom.bind(this)} className="floating-support-chat__header__close">
                <img src={close} alt="close" />
              </button>
            </div>
            <ChatRoom
              mode="float_chatroom"
              chatroomId={this.props.chatroomId}
            />
          </div>
        </div>
      }
      <button onClick={this.handleToggleChatroom.bind(this)} className="btn-open-chat">
        <div className="btn-open-chat__inner">
          <img className="" src={iconSupportChat} alt='iconChat' />
          <span>サポート</span>
          <span className="d-none d-lg-inline">チャット</span>
          {
            this.props.unreadChatrooms.length ? <div className="btn-open-chat__notification-count">{this.props.unreadChatrooms.length}</div> : null
          }
        </div>
      </button>
    </div>
  }
}

export default FloatingSupportChat



// WEBPACK FOOTER //
// ./src/components/FloatingSupportChat/FloatingSupportChat.js